var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.5H36C36.7956 16.5 37.5587 16.8161 38.1213 17.3787C38.6839 17.9413 39 18.7044 39 19.5V37.5C39 37.8978 38.842 38.2794 38.5607 38.5607C38.2794 38.842 37.8978 39 37.5 39H10.5C10.1022 39 9.72064 38.842 9.43934 38.5607C9.15804 38.2794 9 37.8978 9 37.5V19.5C9 18.7044 9.31607 17.9413 9.87868 17.3787C10.4413 16.8161 11.2044 16.5 12 16.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.75H18",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 16.5V10.5C14.25 10.1022 14.408 9.72064 14.6893 9.43934C14.9706 9.15804 15.3522 9 15.75 9H32.25C32.6478 9 33.0294 9.15804 33.3107 9.43934C33.592 9.72064 33.75 10.1022 33.75 10.5V16.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 33.75H13.5",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 27.75H33C33.3978 27.75 33.7794 27.908 34.0607 28.1893C34.342 28.4706 34.5 28.8522 34.5 29.25V39H13.5V29.25C13.5 28.8522 13.658 28.4706 13.9393 28.1893C14.2206 27.908 14.6022 27.75 15 27.75Z",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterPoi);
export default __webpack_public_path__ + "static/media/printer-poi.fc056d1afe46feb4e5b15d68286f293a.svg";
export { ForwardRef as ReactComponent };